import { ConversationResolvedStateToggledEntry } from 'lib-shared-legacy-types';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationResolvedStateToggledProps = {
  entry: ConversationResolvedStateToggledEntry;
};

export const ConversationResolvedStateToggled = ({
  entry,
}: ConversationResolvedStateToggledProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);

  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const text = (
    <>
      Conversation is {entry.is_resolved ? 'resolved' : 'un-resolved'} by{' '}
      {authorLink}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
